export default {
  placeholders: {
    first_name: 'Prénom',
    last_name: 'Nom',
    email: 'E-mail',
    mobile_number: 'Numéro de mobile',
  },
  labels: {
    exclusive_offers_via_email: 'Je souhaite recevoir des offres exclusives et des actualités par e-mail.',
  },
  buttons: {
    sign_up: "S'inscrire",
  },
};
